import React from 'react'
import { Link } from 'react-router-dom'
import './ReturnsPolicy.css'

const ReturnsPolicy = () => {
  return (
    <div className='returns-policy-page'>
      <div className='refund-policy-container'>
        <h1>Returns &amp; Refund Policy</h1>

        <p className='refund-policy-intro'>
          At Tager's Shoppe, we want you to be satisfied with your purchase. If you are not entirely happy with your order, we are here to help.
        </p>

        <div className='refund-policy-content'>

          <div className='refund-policy-block'>
            <h2>1. Cooling-Off Period and Returns</h2>
            <p>In accordance with the Electronic Communications and Transactions Act, you are entitled to cancel your purchase within 7 days of receiving your items for a full refund, subject to the following conditions:</p>
            <ul>
              <li><strong>Condition:</strong> The items must be unopened, unused, and in their original factory-sealed packaging. Due to the nature of our products (e.g., Trading Card Games, board games with components), we cannot accept returns on items where the shrink-wrap or security seals have been broken.</li>
              <li><strong>Return Shipping:</strong> The cost of returning the item to our store is the responsibility of the customer. We recommend using a trackable shipping service, as we cannot guarantee receipt of returned items.</li>
            </ul>
          </div>

          <div className='refund-policy-block'>
            <h2>2. Defective or Damaged Items</h2>
            <p>If you receive an item that is damaged in transit or has a manufacturing defect (e.g., missing components or printing errors):</p>
            <ul>
              <li><strong>Reporting:</strong> Please notify us at info@tagershoppe.com within 48 hours of delivery. Please include photos of the damage and your order number.</li>
              <li><strong>Resolution:</strong> We will arrange for a courier collection of the defective item. Once inspected, we will offer a replacement, a store credit, or a full refund.</li>
              <li><strong>Manufacturer Defects:</strong> For certain products, we may facilitate a request for replacement parts directly from the supplier to resolve the issue quickly.</li>
            </ul>
          </div>

          <div className='refund-policy-block'>
            <h2>3. Non-Returnable Items</h2>
            <p>The following items cannot be returned or exchanged:</p>
            <ul>
              <li><strong>TCG Singles and Sealed Product:</strong> Due to market volatility, Trading Card Game singles and sealed "blind" products (booster packs) are non-returnable.</li>
              <li><strong>Gift Cards:</strong> Digital or physical gift cards cannot be redeemed for cash.</li>
              <li><strong>Sale Items:</strong> Items purchased on "Clearance" or during specific "Flash Sales" are considered final sale unless defective.</li>
            </ul>
          </div>

          <div className='refund-policy-block'>
            <h2>4. Pre-order Cancellations</h2>
            <p>You may cancel a pre-order for a full refund at any time before the item has been dispatched.</p>
            <p><strong>Note:</strong> If a pre-order is cancelled after we have specifically secured stock for you, or if it is a high-value special import, we reserve the right to charge a 10% administration/restocking fee.</p>
          </div>

          <div className='refund-policy-block'>
            <h2>5. Refunds</h2>
            <p>Once your return is received and inspected, we will send you an email to notify you of the approval or rejection of your refund.</p>
            <ul>
              <li><strong>Approved Refunds:</strong> Refunds will be processed via EFT within 2 to 3 business days.</li>
              <li><strong>Store Credit:</strong> If you prefer, we can issue store credit immediately upon approval of the return.</li>
            </ul>
          </div>

        </div>

        <div className='refund-policy-footer'>
          <p>For any questions regarding our refund policy, please <Link to='/ContactUs'>contact us</Link>.</p>
        </div>
      </div>
    </div>
  )
}

export default ReturnsPolicy
